<template>
  <div class="profile">
    <v-layout row wrap>
      <v-flex lg6 md8 sm10 xs10 class="center">
        <v-container grid-list-md class="pa-2 container-width">
          <div class="card-class">
            <v-toolbar id="toolbar" class="toolbar-style">
              <v-spacer></v-spacer>
              <v-toolbar-title>Contact & Email</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                small
                color="white"
                style="border-radius: 10px"
                @click="openEditDialog()"
                >Edit</v-btn
              >
            </v-toolbar>
            <v-card color="white" class="black--text">
              <v-container fluid grid-list-lg class="container-style">
                <v-layout row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Contact Person: <b>{{ userInfo.name }}</b>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Phone Number:
                        <b>{{ iso_phones.iso_phone_number ? iso_phones.iso_phone_number : "N/A" }}</b>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Phone Type:
                        <b>{{ iso_phones.iso_phone_type ? iso_phones.iso_phone_type : "N/A" }}</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Address:
                        <b>{{ iso_address.iso_street ? iso_address.iso_street : 'N/A'}}</b>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        City:
                        <b>{{ iso_address.iso_city ? iso_address.iso_city : 'N/A' }}</b>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        State:
                        <b>{{iso_address.iso_state ? iso_address.iso_state : 'N/A'}}</b>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Zip:
                        <b>{{ iso_address.iso_zip ? iso_address.iso_zip : 'N/A' }}</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </div>
          <br />
          <div class="card-class">
            <v-toolbar id="toolbar" class="toolbar-style">
              <v-spacer></v-spacer>
              <v-toolbar-title>Login Credentials</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                small
                color="white"
                style="border-radius: 10px"
                @click="openPasswordDialog()"
                >Reset</v-btn
              >
            </v-toolbar>
            <v-card color="white" class="black--text">
              <v-container fluid grid-list-lg class="container-style">
                <v-layout row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        User Name: <b>{{ userInfo.email }}</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Password: <b>************</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </div>
          <br />
          <div class="card-class">
            <v-toolbar id="toolbar" class="toolbar-style">
              <v-spacer></v-spacer>
              <v-toolbar-title>Bank Account</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                small
                color="white"
                style="border-radius: 10px"
                @click="openBankAccountDialog()"
                >Edit</v-btn
              >
            </v-toolbar>
            <v-card color="white" class="black--text">
              <v-container fluid grid-list-lg class="container-style">
                <v-layout row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Bank Name:
                        <b>{{ iso_bank_account.iso_account_name ? iso_bank_account.iso_account_name : 'N/A' }}</b>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Account Number:
                        <b>{{iso_bank_account.iso_account_number?iso_bank_account.iso_account_number: 'N/A'}}</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg12 md12 sm12 xs12>
                        Routing Number:
                        <b>{{ iso_bank_account.iso_account_routing_number ? iso_bank_account.iso_account_routing_number : 'N/A'}}</b>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </div>
        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog v-model="editDialog" v-if="editDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Contact & Email</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeEditDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.name"
                    label="Contact Person"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="iso_phones.iso_phone_number"
                    label="Phone Number"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="iso_phones.iso_phone_type"
                    label="Phone Type"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 md6 sm12 xs12>
                    <v-combobox
                      v-model="userInfo.iso_emails"
                      label="Add CC Emails"
                      autocomplete="off"
                      hint="Hit enter to add multiple"
                      persistent-hint
                      hide-selected
                      multiple
                      chips
                    ></v-combobox>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_street"
                    label="Street"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_city"
                    label="City"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 md6 sm12 xs12>
                  <v-select
                    v-model="iso_address.iso_state"
                    :items="state"
                    color="blue darken-2"
                    label="State"
                    return-object
                    autocomplete
                    hide-details
                  ></v-select>
                </v-flex>

                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_zip"
                    label="Zip"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeEditDialog()"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="submitContactInfo()"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResetPassword
      v-if="passwordDialog"
      @closePasswordDialog="closePasswordDialog"
      :passwordDialog="passwordDialog"
    />

    <v-dialog v-model="bankAccountDialog" v-if="bankAccountDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Bank Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeBankAccountDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_name"
                    label="Bank Name"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_number"
                    label="Account Number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_routing_number"
                    label="Routing Number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeBankAccountDialog()"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="updateIsoBankInfo()"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ResetPassword from "./Dialogs/ResetPassword";
import {URL} from '../../env'

export default {
  components: {
    ResetPassword,
  },
  data() {
    return {
      state: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansa",
        "Kentucky",
        "Lousiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      editDialog: false,
      passwordDialog: false,
      bankAccountDialog: false,
      rules: {
        min: (v) => v.length >= 8 || "Min 8 characters",
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      userInfo: {
        syndication:{
          syndicate_phone: {},
          syndicate_address: {}
        }
      },
      iso_address: {},
      iso_phones: {},
      iso_bank_account: {}
    };
  },
  mounted() {
    this.getProfile();
  },

  methods: {
    openEditDialog() {
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
    },

    openPasswordDialog() {
      this.passwordDialog = true;
    },
    closePasswordDialog() {
      this.passwordDialog = false;
    },

    openBankAccountDialog() {
      this.bankAccountDialog = true;
    },
    closeBankAccountDialog() {
      this.bankAccountDialog = false;
    },
    async getProfile() {
      const iso = await axios.get(`${URL}/api/iso/isos/${localStorage.getItem("unique_id")}`);
      const iso_address = await axios.get(`${URL}/api/iso_address/iso_addresses/${localStorage.getItem("iso_id")}`);
      const iso_phones = await axios.get(`${URL}/api/iso_phone/iso_phones/${localStorage.getItem("iso_id")}`);
      const iso_bank_account = await axios.get(`${URL}/api/iso_bank_account/iso_bank_accounts/${localStorage.getItem("iso_id")}`);
      this.userInfo = iso.data[0];
      this.userInfo.iso_emails = this.userInfo.iso_emails ? JSON.parse(this.userInfo.iso_emails) : []
      this.iso_address = iso_address.data.data.length > 0 ? iso_address.data.data[0] : {} 
      this.iso_phones = iso_phones.data.data.length>0 ? iso_phones.data.data[0] : {}
      this.iso_bank_account = iso_bank_account.data.data.length>0 ? iso_bank_account.data.data[0]: {}
    },
    async submitContactInfo() {
      await axios.patch(`${URL}/api/iso/isos/${this.userInfo.id}`, this.userInfo);
      if(this.iso_phones.id){
        await axios.patch(`${URL}/api/iso_phone/iso_phones/${this.iso_phones.id}`, this.iso_phones);
      }else{
        await axios.post(`${URL}/api/iso_phone/iso_phones`, this.iso_phones);
      }

      if(this.iso_address.id){
        await axios.patch(`${URL}/api/iso_address/iso_addresses/${this.iso_address.id}`, this.iso_address);
      }else{
        await axios.post(`${URL}/api/iso_address/iso_addresses`, this.iso_address);
      }
      
      this.closeEditDialog();
    },
    async updateIsoBankInfo() {
     if(this.iso_bank_account.id){
        await axios.patch(`${URL}/api/iso_bank_account/iso_bank_accounts/${this.iso_bank_account.id}`, this.iso_bank_account);
      }else{
        await axios.post(`${URL}/api/iso_bank_account/iso_bank_accounts`, this.iso_bank_account);
      }
      this.closeBankAccountDialog();
      this.getProfile();
    },
  },
};
</script>

<style scoped>
.container-width {
  max-width: 100% !important;
}

.space {
  width: 88px;
}

.profile {
  line-height: 1;
}

.container-style {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
}

.card-class {
  margin: 1px 0px;
}

.esign-email {
  word-wrap: break-word;
}

.toolbar-style {
  height: 40px !important;
  background-color: #cccccc !important;
}
</style>

<style>
#toolbar .v-toolbar__content {
  height: 100% !important;
  width: 100% !important;
}
</style>

<style scoped>
.container-width {
  max-width: 100%;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>